// extracted by mini-css-extract-plugin
export default {"root":"r563lqT8UqYABR_tIWoC","placeHolderShimmer":"Pl6JOLBt2IsROdwg7BdX"};